<i18n>
{
"en": {
  "CENTERS": "Schools",
  "STUDENTS": "Students",
  "BUSES": "Buses",
  "DRIVERS": "Drivers",
  "ABSENCES": "Absences",
  "ROUTES": "Routes",
  "SUPERVISORS": "Supervisors",
  "TOTAL": "Total"
},
"ar": {
  "CENTERS": "مراكز",
  "STUDENTS": "الطلاب",
  "BUSES": "الحافلات",
  "DRIVERS": "السائقين",
  "ABSENCES": "غياب",
  "ROUTES": "خط السير",
  "SUPERVISORS": "المشرفات",
  "TOTAL": "مجموع"
}
}
</i18n>
<template>
<div class="master-dashboard">
    <el-row :gutter="20">
      <el-col :span="3"  align="center">
        <img :src="AWS_ASSETS + 'logo.png'" />
      </el-col>
        <el-col :span="3" style="padding:8px" :key="key" v-for="(obj, key) in summary">
            <el-card align="center" :body-style="{backgroundColor: 'rgb(89, 180, 170)', color: '#fff', 'font-weight' : 'bold'}">
                <div>
                      {{$t('TOTAL') + ' ' + $t(key)}}
                </div>
                <div slot="header" class="clearfix" style="padding:0" :style="{color: key === 'CENTERS' ? '#ACB225' : links[key].color}">
                    <h1>{{obj}} <br/>
                    </h1>
                </div>
            </el-card>
        </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="8" :key="key" v-for="(center, key) in schools">
          <el-button type="text" @click="clickEvent(key)">
            <el-card align="center" :body-style="{padding: '5px 20px'}">
              <el-row :gutter="20">
                <el-col :span="8" :key="index" v-for="(obj, index) in center" v-if="index!='SCHOOL'">
                    <el-button style="width: 100%" type="text" @click.stop="clickEvent(key, index)">
                      <el-card align="center" :body-style="{'font-weight' : 'bold', padding: '10px 30px'}">

                         <div slot="header" class="clearfix" :style="{color: links[index].color}">
                            <h1>{{obj}}</h1>
                        </div>
                        <div>
                              {{$t(index)}}
                        </div>
        
                    </el-card>
                    </el-button>
                </el-col>                
              </el-row>
              <div slot="header" class="clearfix">
                <h2>{{center_name(center)}}</h2>
              </div>
          </el-card>
          </el-button>
      </el-col>
    </el-row>
</div>
</template>

<script>
import { EventBus } from '../event-bus.js'
export default {
  beforeRouteEnter (to, from, next) {
    if (window.location.pathname !== '/') {
      let center = window.location.pathname.replace('/', '')
      window.location.href = location.protocol + '//' + window.location.host + '/' + center
      return
    }
    next()
  },
  data () {
    return {
      schools: {},
      activeNames: [0],
      summary: {},
      cardHeight: 0,
      lang: 'en',
      links: {
        'STUDENTS': {link: 'school/student', color: '#FA7D82'},
        'BUSES': {link: 'transportation/bus', color: '#FCB225'},
        'SUPERVISORS': {link: 'transportation/supervisor', color: '#FE5E41'},
        'DRIVERS': {link: 'transportation/driver', color: '#C5D86D'},
        'ABSENCES': {link: 'attendance/absence', color: '#00798C'},
        'ROUTES': {link: 'transportation/route', color: '#1D1A31'}
      }
    }
  },
  mounted () {
    this.switchLanguage()
    this.lang = localStorage.getItem('lang')
    this.$nextTick(function () {
      this.cardHeight = window.innerHeight - 20
    })
    this.loadData()
    EventBus.$on('langEmit', lang => {
      this.lang = lang
    })
  },
  methods: {
    url_target (target) {
      let hq = target.split('_')[0]
      let center = target.split('_')[1]
      let subdomain = window.location.host.split('.')[0]
      let host = window.location.host.replace(subdomain, hq)
      return location.protocol + '//' + host + '/' + center
    },
    loadData () {
      let self = this
      this.$http.get('dashboard/counts')
        .then(function (response) {
          self.schools = response.data.schools
          self.summary = response.data.summary
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    clickEvent (name, key) {
      let url = this.url_target(name)
      if (key !== undefined) url += '#/' + this.links[key].link
      window.open(url, '_blank')
    },
    center_name (center) {
      return this.lang === 'en' ? center.SCHOOL.Name_EN : center.SCHOOL.Name_AR
    }
  }
}
</script>

<style>
.master-dashboard{padding:10px 15px}
.master-dashboard img{max-width:120px; border-radius: 50%; border:#f5c93c solid 10px}
.master-dashboard .el-collapse .el-card:hover{cursor: pointer;}
.master-dashboard .el-card__header{padding: 5px !important}
</style>



// WEBPACK FOOTER //
// MasterDashboard.vue?916bd4d2